// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1y63U","footer":"ModalCreateQualiphyProcedure_footer__2DlhX","additionData":"ModalCreateQualiphyProcedure_additionData__bxxRm"};